/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomSmsSettings,
  TestSmsRequest,
  TestSmsResponse,
} from '../models/index';
import {
    CustomSmsSettingsFromJSON,
    CustomSmsSettingsToJSON,
    TestSmsRequestFromJSON,
    TestSmsRequestToJSON,
    TestSmsResponseFromJSON,
    TestSmsResponseToJSON,
} from '../models/index';

export interface CreateOrUpdateCustomSmsSettingsRequest {
    customSmsSettings: CustomSmsSettings;
}

export interface SendTestSmsRequest {
    testSmsRequest: TestSmsRequest;
}

/**
 * CustomSMSSettingsApi - interface
 * 
 * @export
 * @interface CustomSMSSettingsApiInterface
 */
export interface CustomSMSSettingsApiInterface {
    /**
     * 
     * @summary Create or update tenant custom SMS settings
     * @param {CustomSmsSettings} customSmsSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSMSSettingsApiInterface
     */
    createOrUpdateCustomSmsSettingsRaw(requestParameters: CreateOrUpdateCustomSmsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomSmsSettings>>;

    /**
     * Create or update tenant custom SMS settings
     */
    createOrUpdateCustomSmsSettings(requestParameters: CreateOrUpdateCustomSmsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomSmsSettings>;

    /**
     * 
     * @summary Delete tenant custom SMS settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSMSSettingsApiInterface
     */
    deleteCustomSmsSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete tenant custom SMS settings
     */
    deleteCustomSmsSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get tenant custom SMS settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSMSSettingsApiInterface
     */
    getCustomSmsSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomSmsSettings>>;

    /**
     * Get tenant custom SMS settings
     */
    getCustomSmsSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomSmsSettings>;

    /**
     * 
     * @summary Send a test SMS to verify configuration
     * @param {TestSmsRequest} testSmsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSMSSettingsApiInterface
     */
    sendTestSmsRaw(requestParameters: SendTestSmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestSmsResponse>>;

    /**
     * Send a test SMS to verify configuration
     */
    sendTestSms(requestParameters: SendTestSmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestSmsResponse>;

}

/**
 * 
 */
export class CustomSMSSettingsApi extends runtime.BaseAPI implements CustomSMSSettingsApiInterface {

    /**
     * Create or update tenant custom SMS settings
     */
    async createOrUpdateCustomSmsSettingsRaw(requestParameters: CreateOrUpdateCustomSmsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomSmsSettings>> {
        if (requestParameters['customSmsSettings'] == null) {
            throw new runtime.RequiredError(
                'customSmsSettings',
                'Required parameter "customSmsSettings" was null or undefined when calling createOrUpdateCustomSmsSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/sms/custom`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CustomSmsSettingsToJSON(requestParameters['customSmsSettings']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomSmsSettingsFromJSON(jsonValue));
    }

    /**
     * Create or update tenant custom SMS settings
     */
    async createOrUpdateCustomSmsSettings(requestParameters: CreateOrUpdateCustomSmsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomSmsSettings> {
        const response = await this.createOrUpdateCustomSmsSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete tenant custom SMS settings
     */
    async deleteCustomSmsSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/sms/custom`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete tenant custom SMS settings
     */
    async deleteCustomSmsSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomSmsSettingsRaw(initOverrides);
    }

    /**
     * Get tenant custom SMS settings
     */
    async getCustomSmsSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomSmsSettings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/sms/custom`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomSmsSettingsFromJSON(jsonValue));
    }

    /**
     * Get tenant custom SMS settings
     */
    async getCustomSmsSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomSmsSettings> {
        const response = await this.getCustomSmsSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Send a test SMS to verify configuration
     */
    async sendTestSmsRaw(requestParameters: SendTestSmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestSmsResponse>> {
        if (requestParameters['testSmsRequest'] == null) {
            throw new runtime.RequiredError(
                'testSmsRequest',
                'Required parameter "testSmsRequest" was null or undefined when calling sendTestSms().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/sms/custom/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestSmsRequestToJSON(requestParameters['testSmsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestSmsResponseFromJSON(jsonValue));
    }

    /**
     * Send a test SMS to verify configuration
     */
    async sendTestSms(requestParameters: SendTestSmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestSmsResponse> {
        const response = await this.sendTestSmsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
